import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import CarContractList from "../../components/CarContract/List/CarContractList";
import { withRouter } from "react-router";

const CarContractListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست معاملات ماشین",
            to: "/car-contract/list",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <CarContractList
            name={props.match.params.name}
            user={props.match.params.id}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(CarContractListPage);
